import KoFiIcon from './platforms/component-lib.esm2.js';
import CalendlyIcon from './platforms/component-lib.esm.js';
import SpotifyIcon from './platforms/component-lib.esm4.js';
import TwitchIcon from './platforms/component-lib.esm3.js';
import PlayCircleOIcon from './component-lib.esm56.js';
import YoutubeIcon from './social-media/component-lib.esm3.js';
import VimeoIcon from './social-media/component-lib.esm.js';
import FacebookLetterFIcon from './social-media/component-lib.esm2.js';
import AppleIcon from './platforms/component-lib.esm5.js';
import ApplePodcastIcon from './platforms/component-lib.esm7.js';
import SoundcloudIcon from './platforms/component-lib.esm6.js';
const VIDEO_ICONS = {
  PlayCircleOIcon,
  YoutubeIcon,
  VimeoIcon,
  FacebookLetterFIcon,
  TwitchIcon
};
const PLATFORM_ICONS = {
  KoFiIcon,
  CalendlyIcon,
  SpotifyIcon,
  AppleIcon,
  ApplePodcastIcon,
  SoundcloudIcon
};
const EMBED_ICONS = {
  ...VIDEO_ICONS,
  ...PLATFORM_ICONS
};
export { EMBED_ICONS, PLATFORM_ICONS, VIDEO_ICONS };